import './MetricVisualization.scss';

export { schema, getSchema, uiSchema } from '../../schemas/MetricVisualizationSchema';

export { default } from './MetricVisualization';
